import {Dictionary} from '@reduxjs/toolkit';
import {Area, Building, Floor} from '../../data/entities';
import {BuildingNode} from './types';

export const getNode = (
  nodeId: string,
  buildings: Dictionary<Building>,
  floors: Dictionary<Floor>,
  areas: Dictionary<Area>,
): BuildingNode | undefined => {
  const foundNode = (buildings[nodeId] || floors[nodeId] || areas[nodeId]) as BuildingNode;
  return foundNode;
};

export const getChildren = (node: BuildingNode) => node.floors || node.areas || [];

export const getBuildingId = (node: BuildingNode) => node.buildingId || node.id;
